import { useAuthContext } from '../../../contexts/AuthProvider';
import { AvailableAssociateRes } from '../../../types/appointments';
import BookingSuggestionRow from '../../AppointmentsComps/BookingComps/BookingSuggestionRow';
import ModalTitle from './ModalTitle';
import ParentModal from './ParentModal';

const BookingSuggestionModal = ({
  handleModalClose,
  gridViewData,
}: {
  handleModalClose: () => void;
  gridViewData: AvailableAssociateRes;
}) => {
  // integration of context hooks here
  const { currentUser } = useAuthContext();

  // function to render booking suggestion row declared here
  const renderBookingSuggestionRows = (): Array<React.ReactNode> => {
    let suggestionRows: Array<React.ReactNode> = [];

    console.log('GRID VIEW DATA: ', gridViewData);

    for (const key in gridViewData.available_associates) {
      suggestionRows.push(
        <BookingSuggestionRow
          key={key}
          date={key}
          associates={gridViewData.available_associates[key].filter(
            (associate) => associate.username !== currentUser?.username
          )}
        />
      );
    }

    return suggestionRows;
  };

  // rendering booking suggestion modal component here
  return (
    <ParentModal
      onClick={handleModalClose}
      customWidthClass='md:w-[750px] xl:w-[1200px]'
    >
      <ModalTitle titleText='booking suggestions' />

      <div className='rounded-lg overflow-hidden overflow-x-auto border-2 border-dashed border-legal-dark-blue'>
        <div className='grid grid-cols-[110px_200px_150px_1fr] border-b-2 [&>div:not(:last-child)]:border-r-2 border-legal-dark-blue border-dashed [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-legal-dark-blue min-h-10 text-sm text-legal-dark-blue font-semibold min-w-[1000px]'>
          <div className='flex items-center justify-center'>Date</div>
          <div className='flex items-center justify-center'>Associate</div>
          <div className='flex items-center justify-center'>Price</div>

          <div className='grid grid-cols-6 [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-legal-dark-blue [&>div:not(:last-child)]:border-dashed'>
            <div className='flex items-center justify-center'>5 AM - 8 AM</div>
            <div className='flex items-center justify-center'>8 AM - 11 AM</div>
            <div className='flex items-center justify-center'>11 AM - 2 PM</div>
            <div className='flex items-center justify-center'>2 PM - 5 PM</div>
            <div className='flex items-center justify-center'>5 PM - 8 PM</div>
            <div className='flex items-center justify-center'>8 PM - 11 PM</div>
          </div>
        </div>

        {renderBookingSuggestionRows()}
      </div>
    </ParentModal>
  );
};

export default BookingSuggestionModal;
